
import { useTimeSlotQueries } from './useTimeSlotQueries';
import { useTimeSlotMutations } from './useTimeSlotMutations';

export const useTimeSlots = () => {
  const { timeSlots, isLoading, error } = useTimeSlotQueries();
  const mutations = useTimeSlotMutations();

  return {
    timeSlots,
    isLoading,
    error,
    ...mutations,
  };
};

export type { TimeSlotInsert, TimeSlotUpdate } from './types';
